(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "@vivo/smooth-scrollbar", "@vivo/smooth-scrollbar/plugins/overscroll/index.js", "./horizon.js"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("@vivo/smooth-scrollbar"), require("@vivo/smooth-scrollbar/plugins/overscroll/index.js"), require("./horizon.js"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.smoothScrollbar, global.index, global.horizon);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _smoothScrollbar, _index2, _horizon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _smoothScrollbar = _interopRequireDefault(_smoothScrollbar);
  _index2 = _interopRequireDefault(_index2);
  _horizon = _interopRequireDefault(_horizon);

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  _smoothScrollbar.default.use(_horizon.default, _index2.default);

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        ref: "scroll",
        staticClass: "nx-scroll-view-three",
        style: {
          fontSize: _vm.scrollFontSize
        }
      }, [_c('div', {
        ref: "scroll-content",
        staticClass: "nx-scroll-view-three-content"
      }, [_vm._t("default")], 2)]);
    },
    name: 'nx-scroll-view-three',
    data: function data() {
      return {
        bs: undefined,
        scrollFontSize: ''
      };
    },
    props: {
      scrollProps: {
        type: Object,
        default: function _default() {
          return {};
        }
      }
    },
    beforeDestroy: function beforeDestroy() {
      var _this$bs;

      (_this$bs = this.bs) === null || _this$bs === void 0 ? void 0 : _this$bs.destroy();
      this.bs = undefined;
    },
    mounted: function mounted() {
      this.init();
    },
    updated: function updated() {
      this.resetFontSize();
    },
    methods: {
      init: function init() {
        this.bs = _smoothScrollbar.default.init(this.$refs.scroll, _objectSpread({
          damping: 0.05,
          thumbMinSize: 20,
          renderByPixels: !('ontouchstart' in document),
          alwaysShowTracks: false,
          continuousScrolling: true,
          plugins: {
            horizon: {},
            overscroll: {}
          }
        }, this.scrollProps));
        this.resetFontSize();
      },
      resetFontSize: function resetFontSize() {
        var _this$$refs$scrollCo;

        // 如果内容层高度为0，则设置字体为0，否则会有高度
        var offsetHeight = (_this$$refs$scrollCo = this.$refs['scroll-content']) === null || _this$$refs$scrollCo === void 0 ? void 0 : _this$$refs$scrollCo.offsetHeight;
        this.scrollFontSize = offsetHeight ? '' : 0;
      },
      getBS: function getBS() {
        return this.bs;
      },
      scrollIntoView: function scrollIntoView(dom, options) {
        this.bs.scrollIntoView(dom, options);
      },
      scrollTo: function scrollTo(x, y, duration, options) {
        this.bs.scrollTo(x, y, duration, options);
      }
    }
  };
  _exports.default = _default2;
});